import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useQuery } from "@tanstack/react-query";

export const useUserClassrooms = () => {
  const queryFn = useApiRequest({
    url: "users/me/classrooms",
    method: HttpMethod.Get,
  });

  return useQuery({
    queryKey: ["user-classrooms"],
    queryFn,
  });
};
